import { render, staticRenderFns } from "./TestimonialList.vue?vue&type=template&id=2d70cf40"
import script from "./TestimonialList.vue?vue&type=script&lang=js"
export * from "./TestimonialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports